import { DefaultQueryParams, parseQuery } from '@pascal/pascal-core';

export const NOTIFICATION_TEXT = {
  NO_MORE_BETS: 'NO_MORE_BETS',
  DEALING_TIME: 'DEALING_TIME',
};

export const BET_WIN_TYPE = {
  BlackJack: 8,
  Lose: 9,
  Win: 10,
  Surrender: 11,
  Push: 12,
};

export const IDS = [1, 2, 3, 4, 5, 6];

export const ANIMATION_DURATION = 3000;

export const SHUFFLE_CARDS_COUNT = new Array(45).fill(null).map((item, index) => index);

// game rules keys = 45
export const GAME_HISTORY_BETS_COUNTS = new Array(3).fill(null).map((item, index) => index);
export const GAME_RULES_HELP_KEYS = new Array(27).fill(null).map((item, index) => index);
export const GAME_RULES_HELP_KEYS_TURBO = new Array(61).fill(null).map((item, index) => index);

export const SOCKET_METHODS = {
  TURBO_BET_ACCEPTED: 'TurboBetAccepted',
  DECISION_TIME: 'DecisionTime',
  SHUFFLE_CARDS: 'ShuffleCards',
  CARD_RESULT: 'CardResult',
  AUTO_STAND_RESULT: 'AutoStandResult',
  INSURANCE: 'Insurance',
};

export const DECISION_ACCEPTED_CODE = 0;

export const SOCKET_DECISIONS_METHODS = [
  'SplitResult',
  'StandResult',
  'HitResult',
  'DoubleResult',
  'SurrenderResult',
  'InsuranceResult',
  'InsuranceInfoResult',
];

export const DECISION_RESULT_EVENTS = {
  HitResult: 'HitResult',
  StandResult: 'StandResult',
  SplitResult: 'SplitResult',
  DoubleResult: 'DoubleResult',
  SurrenderResult: 'SurrenderResult',
  InsuranceResult: 'InsuranceResult',
  InsuranceInfoResult: 'InsuranceInfoResult',
};

export const SOCKET_INVOKE_TARGETS = {
  0: 'Hit',
  1: 'Stand',
  2: 'Double',
  3: 'Split',
  4: 'Surrender',
};

export const TERMINAL_ID = 88;
export const TURBO_ID = 20;

const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
const isTerminal = +gameId === TERMINAL_ID;

export const TURBO_OR_TERMINAL_GAME_ID = isTerminal ? TERMINAL_ID : TURBO_ID;

export const INSURANCE_ODD = 3;

export const DECISIONS_MODELS = [
  {
    type: 4,
    name: 'SURRENDER',
    iconName: 'icon-surrender-flag',
    className: 'tb-min-button surrender',
  },
  { type: 0, name: 'HIT', iconName: 'icon-rounded-plus', className: 'tb-boolean-btn-yes' },
  { type: 1, name: 'STAND', iconName: 'icon-rounded-minus', className: 'tb-boolean-btn-no' },
  { type: 2, name: 'DOUBLE', iconName: 'icon-double', className: 'tb-min-button double' },
  { type: 3, name: 'SPLIT', iconName: 'icon-split', className: 'tb-min-button split' },
];

export const SURRENDER_TYPE = 4;
export const INSURANCE_TYPE = 5;
export const DOUBLE_BET_CODE = 2;
export const SPLIT_BEY_CODE = 3;
export const INSURANCE_BET_CODE = 3;
export const INSURANCE_ACTION = {
  YES: true,
  NO: false,
};

export const BLACK_JACK_POINT = 21;

export const SPLIT_HAND_TYPE = 1;
export const MAIN_HAND_TYPE = 0;
